import Vue from 'vue'
import companyConstant from '../../area-contract/constants/companyConstant'
import contractConstant from '../../area-contract/constants/contractConstant'

Vue.filter('empty', function (val) {
  if (val === '' || !val) {
    return '--'
  } else {
    return val
  }
})
Vue.filter('priceNumber2', function (val) {
  if (val === '' || !val) {
    return '0.00'
  } else {
    return val / 100
  }
})

Vue.filter('priceNumber', function (val) {
  if (val === '' || !val) {
    return '0.00'
  } else {
    // 强制补充2位小数
    val = Math.round(val * 100) / 100
    var str = val.toString()
    var rs = str.indexOf('.')
    if (rs < 0) {
      rs = str.length
      str += '.'
    }
    while (str.length <= rs + 2) {
      str += '0'
    }
    let res = str.toString().replace(/\d+/, function (n) { // 先提取整数部分
      return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
        return $1 + ','
      })
    })
    return res
  }
})
Vue.filter('priceNumber_', function (val) {
  if (val === '' || !val) {
    return '--'
  } else {
    // 强制补充2位小数
    val = Math.round(val * 100) / 100
    var str = val.toString()
    var rs = str.indexOf('.')
    if (rs < 0) {
      rs = str.length
      str += '.'
    }
    while (str.length <= rs + 2) {
      str += '0'
    }
    let res = str.toString().replace(/\d+/, function (n) { // 先提取整数部分
      return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
        return $1 + ','
      })
    })
    return res
  }
})
Vue.filter('priceNumberPro', function (val) {
  if (val === '' || !val) {
    return '0.00'
  } else {
    // 强制补充2位小数
    val = Math.round(val * 100) / 100
    var str = val.toString()
    var rs = str.indexOf('.')
    if (rs < 0) {
      rs = str.length
      str += '.'
    }
    while (str.length <= rs + 2) {
      str += '0'
    }
    return str
  }
})
Vue.filter('priceSixNumber', function (val) {
  if (val === '' || !val) {
    return '0.000000'
  } else {
    // 强制补充6位小数
    val = Math.round(val * 1000000) / 1000000
    var str = val.toString()
    var rs = str.indexOf('.')
    if (rs < 0) {
      rs = str.length
      str += '.'
    }
    while (str.length <= rs + 6) {
      str += '0'
    }
    return str
  }
})

Vue.filter('formatOrgType', (val) => {
  if (typeof (val) === 'number') {
    const find = companyConstant.orgType.find(item => item.value === val)
    if (find) return find.label
    return '--'
  }
})

Vue.filter('billTypeFilter', val => {
  const find = contractConstant.billTypeList.find(item => item.value === val)
  if (find) return find.label
  return '--'
})



// WEBPACK FOOTER //
// ./src/area-base/filters/index.js